import {createAction} from "@reduxjs/toolkit";

export const setArticle = createAction('SET_ARTICLE');